import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeColors } from '../../Themes/Modes'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 70,
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 16,
  },
  scrollViewContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  titleStyle: {
    fontSize: Fonts.size.h5,
  },
  subtitleStyle: {
    fontSize: Fonts.size.h6,
  },
  afterSubtitleStyle: {
    marginLeft: 10,
    marginBottom: -2,
  },
  scrollViewContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  subheaderRightContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 30
  },
  subheaderRightIcon: {
    marginLeft: 8,
  },
  contentContainer: {
    flexGrow: 1,
    paddingTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 20,
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 20,
  },
  selectRecipiantText: {
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 30,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 16 : null
  },
  serviceDescription: theme => ({
    marginBottom: 20,
    marginTop: 10,
    textAlign: 'left',
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
    color: theme.colors.textColor,
    lineHeight: 18,
  }),
  serviceAmount: {
    fontWeight: 'bold',
  },
  button: {
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 15,
    marginTop: 5,
    marginBottom: 30,
  },
  disabledButton: theme => ({
    backgroundColor: getThemeColors(theme.name).disabled
  }),
  card: {
    marginVertical: 20,
    padding: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 20 : 16,
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 32 : 20,
    minHeight: 300,
    width: '100%'
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileIcon: {
    marginRight: 10,
  },
  line: theme => ({
    marginTop: 20,
    backgroundColor: theme.colors.divider,
    marginBottom: 10,
  }),
  contactContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inputContainer: {
    flex: 1,
    minHeight: 50,
    marginHorizontal: 0,
  },
  inputText: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VFFont,
  }),
  selectContactBtn: {
    backgroundColor: Colors.light_grey,
    borderRadius: 6,
    padding: 2,
    height: 44,
    marginTop: 23,
    marginLeft: 10,
  },
  successContainer: theme => ({
    flexGrow: 1,
    backgroundColor: theme.colors.backgroundColor,
  }),
  contentWrapper: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  image: {
    alignSelf: 'center',
    marginBottom: 20,
  },
  textContainer: {
    alignItems: 'center',
  },
  description: {
    textAlign: 'center',
    marginVertical: 20,
  },
  stepButton: {
    marginHorizontal: 16,
    marginBottom: 25,
  },
  containerSafe: (len) => ({
    flex: 1,
    minHeight: len * 130,
  }),
  closeIcon: (color = Colors.white) => {
    return {
      tintColor: color,
    }
  },
  headerContentWrapper: (top = 0) => {
    return {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 24 + top,
      marginHorizontal: 16,
      marginBottom: 5,
    }
  },
})

export default styles
